import { getGetAPIMethod, getPostAPIMethod } from "@neum/frontend-shared/utils/api";
import { components } from "@neum/frontend-shared/types/gen/services";
import config from "../../../config.json";

const baseUrl = (import.meta.env.REACT_APP_ENDPOINT ?? config.ENDPOINT) as string;

export type VerifiedPhoneNumber = components["schemas"]["VerifiedPhoneNumber"];

export const getVerifiedPhoneNumbers = getGetAPIMethod("/v1/phone/numbers", { baseUrl });
export const startPhoneCall = getPostAPIMethod("/v1/phone/start_call", { baseUrl });
